import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AdditionalInfoCollapsible } from "../components/accordions/AdditionalInfoCollapsible";
import { ERROR_VIEW_NAME } from "../core/constants";
import { translate } from "../core/i18n";
import { getDomainCfg, store } from "../core/state";
import { getViewData, setViewData } from "../core/views";
import { getRedirectUrl, redirectTo } from "../features/redirect";

interface ErrorData {
  name: string;
  title: string;
  image: string;
  description: string;
  detail: string;
  help: string;
  url: string;
}

export function setErrorViewData(name : string) : void {
  const errorState : any = getViewData(ERROR_VIEW_NAME);
  if (errorState) {
    errorState.data = { name };
    setViewData(ERROR_VIEW_NAME, errorState);
  }

}

function getErrorData(errors: ErrorData[], errorName: string): ErrorData {
  let error: ErrorData | undefined = errors?.find(error => error.name === errorName);
  if (!error) {
    error = errors?.find(error => error.name === "ERROR");
  }

  if (!error) {
    error = getErrorDummy();
  }
  return error;
}

export function getErrorDummy() : ErrorData {
  return {
    name: "ERRORS_NOT_INITIALIZED",
    title: "INIT ERROR",
    image: "/assets/img/404error.png",
    description: "cfg not available!",
    detail: "Look's like your configuration wasn't loaded properly. Check app and domain cfg",
    help: "Check your app configuration!",
    url: "/"
  };
}

export function ErrorView() {
  const [errorState] = store.useState(ERROR_VIEW_NAME);
  const errorName = errorState?.data?.name;
  const errorData: ErrorData = getErrorData(errorState?.cfg?.errors, errorName);

  const exitRequested = () => {
    redirectTo(getRedirectUrl(getDomainCfg().viewSettings.projectsView));
  }

  const exitButton = <button className="btn btn-outline-secondary round-button btn-icon mb-10" title={translate('exit-btn-title')} onClick={exitRequested}>
    <FontAwesomeIcon icon="home" /></button>;

  return (
  <div className="container portal">
    <div className="text-end"> { exitButton }</div>
    <div className="rounded-lg shadow p-3 mb-5 container-app-style" id="portal">
      <h2>{errorData?.title}</h2>
      <a href={errorData.url} title={errorData.help}><img src={errorData.image} alt="errorimage" className="imgcenter img-fluid" /></a>
      <AdditionalInfoCollapsible text={errorData.description} detail={errorData.detail} />
      <p>{errorData.help}</p>
      <a href={errorData.url} className="btn btn-primary btn-lg active" role="button" aria-pressed="true">Zurück</a>
    </div>
  </div>);
}
